export default __webpack_public_path__ + "static/media/mid-k-2-med.cd86e778.jpg";